@import '../../scss/utility';

wb-aspect-ratio {
  position: relative;
  display: block;
  width: 100%;

  .wb-aspect-ratio__target {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    object-fit: cover;
  }

  figcaption {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  img {
    @include _wbNormalizeImg;
  }

  @include wb-image-ratios('.wb-aspect-ratio__height-controller');
}
